import React from "react";
import {
  Box,
  FormLabel,
  Heading,
  Input,
  List,
  ListItem,
} from "@chakra-ui/react";

export const SelectionBox2 = ({
  selectedValue,
  items,
  onSelect,
  name,
  padding,
}) => {
  return (
    <Box
      style={{
        margin: "20px 0 40px",
      }}
    >
      <Heading
        as="h6"
        style={{
          lineHeight: "20px",
          fontSize: "18px",
          fontWeight: "500",
          textTransform: "capitalize",
          marginBottom: "15px",
          textAlign: "center",
        }}
      >
        Select {name}
      </Heading>
      <List
        style={{
          listStyle: "none",
          margin: "0 15px 0 0",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        {React.Children.toArray(
          items.map((item) => (
            <ListItem
              style={{
                display: "inline-block",
                border: "1px solid rgb(0, 176, 255)",
                borderRadius: "4px",
                padding: "10px",
                cursor: "pointer",
                margin: "0 5px 5px 0",
                color: "#000",
                position: "relative",
                boxSizing: "border-box",
                width: "25%",
                backgroundColor: "#fff",
                ...(padding
                  ? {
                      padding: "10px 20px",
                    }
                  : {}),
                ...(selectedValue === item.statementNotation
                  ? {
                      backgroundColor: "#00b0ff",
                      color: "#fff",
                      fontWeight: "700",
                    }
                  : {}),
              }}
              _hover={{
                backgroundColor: "#00b0ff",
                color: "#fff",
                fontWeight: "700",
              }}
            >
              <FormLabel
                htmlFor={item}
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  margin: "0",
                }}
              >
                <Box
                  as="span"
                  style={{
                    fontWeight: "500",
                  }}
                >
                  <Box as="span" style={{ fontWeight: "700" }}>
                    Name:
                  </Box>
                  {item.statementNotation}
                </Box>
                <br />
                <Box as="span">
                  <Box as="span" style={{ fontWeight: "700" }}>
                    Desc:
                  </Box>{" "}
                  {item.description}
                </Box>
                <Input
                  style={{
                    appearance: "none",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  disabled={
                    item === "NGSS" || item === "Science" || item === "English"
                  }
                  name="item"
                  type="radio"
                  value={item.statementNotation}
                  onChange={(e) => onSelect(name, e.target.value)}
                  checked={selectedValue === item.statementNotation}
                />
              </FormLabel>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  );
};
